import { CartLinesUpdateEvent } from '@shopify/events';

if (!customElements.get('fl-shipping-protection')) {
  customElements.define(
    'fl-shipping-protection',
    class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.fl-sp__input');
        this.input?.addEventListener('change', () => this.update(this.input.checked));
        // В корзине осталась только защита — убираем её
        if (this.dataset.orphan === 'true') this.update(false);
      }

      async update(add) {
        if (this.busy) return;
        this.busy = true;
        this.classList.add('fl-sp--busy');
        const id = this.dataset.variantId;
        const sections = [...document.querySelectorAll('cart-items-component')]
          .map((el) => el.dataset.sectionId)
          .filter(Boolean)
          .join(',');
        const body = add ? { items: [{ id: Number(id), quantity: 1 }] } : { id, quantity: 0 };
        Object.assign(body, { sections, sections_url: window.location.pathname });

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: add ? 'add' : 'remove',
            context: 'cart',
            lines: [add ? { merchandiseId: id, quantity: 1 } : { id, quantity: 0 }],
            promise: deferred.promise,
          })
        );

        try {
          const res = await fetch(add ? Theme.routes.cart_add_url : Theme.routes.cart_change_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message || 'Cart update failed');
          const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { sections: data.sections, itemCount: cart.item_count, source: 'fl-shipping-protection' },
          });
        } catch (error) {
          deferred.reject(error);
          if (this.input) this.input.checked = !add;
        } finally {
          this.busy = false;
          this.classList.remove('fl-sp--busy');
        }
      }
    }
  );
}
